import { render, staticRenderFns } from "./InputInteger.vue?vue&type=template&id=0998588a&scoped=true&"
import script from "./InputInteger.vue?vue&type=script&lang=js&"
export * from "./InputInteger.vue?vue&type=script&lang=js&"
import style0 from "./InputInteger.vue?vue&type=style&index=0&id=0998588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998588a",
  null
  
)

export default component.exports